import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import { Link } from "react-router-dom";
import AccordionCard from "./Accordion";
import Button from "@material-ui/core/Button";
import { Box } from "@material-ui/core";

import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";

const OMS_ITEMS = [
  {
    id: "online-plus",
    title: "آنلاین پلاس",
    link: "https://online.pouyanbroker.ir/Account/Login",
    badge: "تدبیر",
  },
  {
    id: "exir",
    title: "اکسیر",
    link: "https://poyan.exirbroker.ir",
    badge: "رایان",
  },
  { id: "kaman", title: "کمان", link: "https://kaman.pouyanbroker.ir" },
  {
    id: "coin",
    title: "گواهی سپرده مشتقه کالایی",
    link: "https://coinonline.pouyanbroker.ir",
  },
];

const useStyles = makeStyles((theme) => ({
  root: {
    width: "95%",
    display: "flex",
    margin: "0px auto",
    justifyContent: "space-between",
    zIndex: 2,
    position: "relative",
    alignItems: "center",
    padding: "20px 0px",
  },
  logo: {
    width: 170.5,
    height: 45,
  },
  enterHomeRoot: {
    backgroundColor: "transparent",
    border: "1px solid white",
    color: "white",
    padding: "5.5px 30px",
    margin: "1px 5px",
    "&:active": {
      backgroundColor: "transparent",
    },
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  buttuns: {
    display: "flex",
  },
  enterHome: {
    backgroundColor: "transparent",
    border: "1px solid white",
    boxShadow: 0,
    color: "white",
    padding: "5.5px 30px",
    margin: "0 5px",
    "&:active": {
      backgroundColor: "transparent",
    },
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  navbar: {
    width: 40,
    height: 40,
    [theme.breakpoints.down("sm")]: {
      border: "1px solid #B5B5B5",
      borderRadius: 7,
    },
  },
  list: {
    width: "100%",
    display: "contents",
  },
  fullList: {
    width: "auto",
  },
  item: {
    width: "100%",
    height: "70vh !important",
    overflow: "auto",
  },
  enter: {
    backgroundColor: "white",
    border: "1px solid gray",
    padding: "5.5px 30px",
    margin: "0 5px",
    "&:active": {
      backgroundColor: "white",
    },
    "&:hover": {
      backgroundColor: "white ",
    },
  },
  openAccount: {
    backgroundColor: theme.palette.light.type2,
    color: "white",
    margin: "0 2px",
    minWidth: "150px",
    padding: "9px 10px",
    "&:active": {
      backgroundColor: theme.palette.light.type2,
    },
    "&:hover": {
      backgroundColor: theme.palette.light.type2,
    },
  },
  topBox: {
    margin: 20,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    position: "relative",
    "& svg": {
      width: 40,
      height: 38,
      cursor: "pointer",
      position: "absolute",
      top: 0,
      right: 0,
    },
  },
  listItem: {
    padding: 0,
    margin: 0,
  },
  itemText: {
    padding: "26px 31px",
    borderBottom: "1px solid #DCDCDC",
    margin: 0,
    textAlign: "center !important",
  },
  bottomBox: {
    height: 83,
    backgroundColor: "#DA212EAli",
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    fontWeight: 600,
    padding: "0 25px",
    position: "absolute",
    bottom: 0,
    width: "100%",
  },
  header: {
    width: "100%",
    textAlign: "center",
  },
  buttons: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    // flexDirection:'column',
    zIndex: 1000,
    paddingBottom: 10,
  },
  btnOtline: {
    backgroundColor: "white",
    color: "#d41217",
    margin: "0 5px",
    padding: "9px 20px",
    border: `1px solid #d41217`,
    [theme.breakpoints.down("1236")]: {
      padding: "9px 5px",
    },
    "&:hover": {
      backgroundColor: "#d41217",
      color: "white",
    },
  },
  mergeButtons: {
    width: 280,
    padding: "0px 07px",
    height: 44,
    borderRadius: 5,
    backgroundColor: "#F4F4F4",
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
  },
  text: {
    fontSize: 14,
    marginBottom: 0,
    "&:hover": {
      color: "red",
      cursor: "pointer",
    },
  },
  line: {
    width: 1,
    height: 22,
    backgroundColor: "rgba(0,0,0,0.5)",
    // border:'0.5px solid rgba(0,0,0,1)'
  },
  toggleButton: {
    "& .MuiPaper-root": {
      top: "70px !important",
      zIndex: 10000000000,
    },
  },
  badge: {
    background: "#DDE0FF",
    display: "inline-block",
    padding: "5px 8px ",
    borderRadius: 9,
    fontSize: 10,
    marginLeft: 5,
    color: "#5A68B2",
  },
  btnOms: {
    padding: "0px 16px",
    height: 44,
    borderRadius: 5,
    backgroundColor: "#FFD9D9",
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    marginRight: 10,
    color: "#E60001",
    cursor: "pointer",
    whiteSpace: "nowrap",
    width: 160,
    [theme.breakpoints.down("1071")]: {
      marginBottom: 5,
      marginRight: 0,
      width: 220,
      justifyContent: "center",
    },
    marginBottom: 5,
    marginRight: 0,
    width: 220,
    justifyContent: "center",
  },
  cardButton: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexWrap: "wrap",
    flexDirection: "column",
    [theme.breakpoints.down("397")]: {
      // marginBottom:10,
    },
  },
  linkTitle: {
    marginRight: "20px",
    marginTop: "10px",
    display: "inline-block",
    "& .title": {
      fontSize: 14,
    },
    "&:hover .title": {
      color: "red !important",
    },
  },
  floatingBar: {
    position: "absolute",
    top: "100%",
    left: 0,
    right: 0,
    width: "100%",
    zIndex: 100,
    display: "flex",
    justifyContent: "center",
    alignItems: "stretch",
    padding: "10px 12px",
    gap: 8,
    boxSizing: "border-box",
  },
  floatingBarCarouselWrap: {
    flex: 1,
    minWidth: 0,
    overflow: "hidden",
  },
  omsCarouselTrack: {
    display: "flex",
    gap: 8,
    overflowX: "auto",
    scrollSnapType: "x mandatory",
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    "&::-webkit-scrollbar": { display: "none" },
    padding: "2px 0",
  },
  omsCarouselSlide: {
    flex: "0 0 auto",
    width: "auto",
    minWidth: 140,
    scrollSnapAlign: "start",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexWrap: "nowrap",
    gap: 6,
    padding: "10px 14px",
    borderRadius: 5,
    backgroundColor: "#ffffff",
    color: "#000000",
    fontSize: 13,
    fontWeight: 600,
    textDecoration: "none",
    textAlign: "center",
    boxSizing: "border-box",
    border: "1px solid rgba(0,0,0,0.08)",
    "&:hover": {
      backgroundColor: "rgba(255,255,255,0.95)",
      color: "#000000",
    },
  },
  omsCarouselBadge: {
    background: "#DDE0FF",
    display: "inline-block",
    padding: "3px 6px",
    borderRadius: 6,
    fontSize: 9,
    marginRight: 4,
    color: "#5A68B2",
  },
  floatingBarBtn: {
    flex: "0 0 auto",
    minWidth: 100,
    padding: "10px 12px",
    borderRadius: 5,
    backgroundColor: "#ffffff",
    color: "#000000",
    border: "1px solid rgba(255,255,255,0.9)",
    fontSize: 13,
    fontWeight: 600,
    "&:hover": {
      backgroundColor: "rgba(255,255,255,0.9)",
      color: "#000000",
    },
  },
}));

export default function HeaderMobile({
  home,
  data,
  flagHeader,
  setflagOms,
  setflagSejam,
}) {
  const handleFloatingOmsOpen = (e) => {
    setAnchorElOms(e.currentTarget);
  };
  const handleFloatingOmsClose = () => {
    setAnchorElOms(null);
  };
  const classes = useStyles();
  const [state, setState] = React.useState({ right: false });
  const [anchorElOms, setAnchorElOms] = React.useState(null);
  const [anchorElOpenAccount, setAnchorElOpenAccount] = React.useState(null);
  const omsCarouselRef = React.useRef(null);
  const autoScrollRef = React.useRef(null);

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ [anchor]: open });
  };

  React.useEffect(() => {
    const el = omsCarouselRef.current;
    if (!el || OMS_ITEMS.length <= 1) return;
    const interval = 3000;
    autoScrollRef.current = setInterval(() => {
      const maxScroll = el.scrollWidth - el.clientWidth;
      if (maxScroll <= 0) return;
      let next = el.scrollLeft + 160;
      if (next >= maxScroll) next = 0;
      el.scrollTo({ left: next, behavior: "smooth" });
    }, interval);
    return () => {
      if (autoScrollRef.current) clearInterval(autoScrollRef.current);
    };
  }, []);

  const handleFloatingOpenAccountOpen = (e) => {
    setAnchorElOpenAccount(e.currentTarget);
  };
  const handleFloatingOpenAccountClose = () => {
    setAnchorElOpenAccount(null);
  };

  const list = (anchor) => (
    <div className={classes.list} role="presentation">
      <Box className={classes.topBox}>
        <img height={50} width={211} src="/assets/images/logo.png" alt="" />

        <Box>
          <svg
            style={{ marginTop: 5 }}
            onClick={toggleDrawer(anchor, false)}
            onKeyDown={toggleDrawer(anchor, false)}
          >
            <use xlinkHref="/sprit.svg#close"></use>
          </svg>
        </Box>
      </Box>

      <Divider />

      <List className={classes.item} style={{ padding: 0 }}>
        {data.map((item, index) => (
          <AccordionCard data={item} key={index} />
        ))}
      </List>
      <div className={classes["cardButton"]} style={{ alignItems: "center" }}>
        <a
          href="https://my.pouyanbroker.ir/"
          target="_blank"
          rel="noopener noreferrer"
          className={classes["btnOms"]}
          style={{ textDecoration: "none" }}
        >
          ورود به مای پویان
        </a>
        <div className={classes["btnOms"]} onClick={() => setflagOms(true)}>
          <svg width={12} style={{ marginLeft: 5 }}>
            <use xlinkHref="/sprit.svg#ref"></use>
          </svg>
          تغییر پنل معاملاتی
        </div>
      </div>
    </div>
  );

  return (
    <div style={{ width: "100%", position: "relative" }}>
      <React.Fragment>
        <Box className={classes.root}>
          <Box>
            <Link to="/">
              <img
                height={"auto"}
                width={211}
                src={
                  home
                    ? "/assets/images/logoWhite.png"
                    : !flagHeader
                    ? "/assets/images/logo.png"
                    : "/assets/images/logoWhite.png"
                }
                alt=""
              />
            </Link>
          </Box>
          <Box className={classes.buttuns}>
            <svg
              className={classes.navbar}
              onClick={toggleDrawer("right", true)}
            >
              <use xlinkHref="/sprit.svg#navbar"></use>
            </svg>
          </Box>
        </Box>

        {/* ردیف دکمه‌های سامانه معاملاتی و افتتاح حساب - فقط موبایل */}
        <Box className={classes.floatingBar}>
          <Button
            className={classes.floatingBarBtn}
            onClick={handleFloatingOmsOpen}
            disableRipple
          >
            سامانه های معاملاتی
          </Button>
          <Menu
            anchorEl={anchorElOms}
            open={Boolean(anchorElOms)}
            onClose={handleFloatingOmsClose}
            getContentAnchorEl={null}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            transformOrigin={{ vertical: "top", horizontal: "center" }}
            PaperProps={{ style: { marginTop: 8 } }}
          >
            <MenuItem onClick={handleFloatingOmsClose}>
              <a
                href={"https://online.pouyanbroker.ir/Account/Login"}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  textDecoration: "none",
                  color: "inherit",
                  display: "flex",
                  alignItems: "center",
                  gap: 6,
                }}
              >
                <span>آنلاین پلاس</span>
                <span className={classes.badge}>تدبیر</span>
              </a>
            </MenuItem>
            <MenuItem onClick={handleFloatingOmsClose}>
              <a
                href={"https://poyan.exirbroker.ir"}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  textDecoration: "none",
                  color: "inherit",
                  display: "flex",
                  alignItems: "center",
                  gap: 6,
                }}
              >
                <span>اکسیر</span>
                <span className={classes.badge}>رایان</span>
              </a>
            </MenuItem>
            <MenuItem onClick={handleFloatingOmsClose}>
              <a
                href={"https://kaman.pouyanbroker.ir"}
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                کمان
              </a>
            </MenuItem>
            <MenuItem onClick={handleFloatingOmsClose}>
              <a
                href={"https://coinonline.pouyanbroker.ir"}
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                گواهی سپرده مشتقه کالایی
              </a>
            </MenuItem>
          </Menu>
          <Button
            className={classes.floatingBarBtn}
            onClick={handleFloatingOpenAccountOpen}
            disableRipple
          >
            افتتاح حساب
          </Button>
          <Menu
            anchorEl={anchorElOpenAccount}
            open={Boolean(anchorElOpenAccount)}
            onClose={handleFloatingOpenAccountClose}
            getContentAnchorEl={null}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            transformOrigin={{ vertical: "top", horizontal: "center" }}
            PaperProps={{ style: { marginTop: 8 } }}
          >
            <MenuItem onClick={handleFloatingOpenAccountClose}>
              <a
                href={"https://reg.pouyanbroker.ir"}
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                بورس اوراق بهادار
              </a>
            </MenuItem>
            <MenuItem onClick={handleFloatingOpenAccountClose}>
              <a
                href={"https://pouyan.ebgo.ir/StockCode"}
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                بورس کال(EBGO)
              </a>
            </MenuItem>
            {setflagSejam && (
              <MenuItem
                onClick={() => {
                  setflagSejam(true);
                  handleFloatingOpenAccountClose();
                }}
              >
                <span style={{ cursor: "pointer" }}>
                  به‌روزرسانی اطلاعات سجام
                </span>
              </MenuItem>
            )}
          </Menu>
        </Box>

        {/* <Button onClick={toggleDrawer("right", true)}>{"right"}</Button> */}
        <SwipeableDrawer
          style={{ zIndex: 10000 }}
          anchor={"right"}
          open={state["right"]}
          onClose={toggleDrawer("right", false)}
          onOpen={toggleDrawer("right", true)}
        >
          {list("right")}
        </SwipeableDrawer>
      </React.Fragment>
    </div>
  );
}
